import type { FareCalculator, FareEstimate } from './FareCalculator'
import type { RouteInfo } from '../types'

/**
 * V0.1에서는 공식 요율과 할증 규칙의 검증이 완료되지 않아 계산을 비활성화한다.
 * 요율을 추가할 때 source와 lastVerifiedDate를 함께 채우고 단위 테스트를 갱신할 것.
 */
export class BusanTaxiFareCalculator implements FareCalculator {
  readonly region = 'Busan'
  readonly source = null
  readonly lastVerifiedDate = null

  estimate(_route: RouteInfo): FareEstimate | null {
    return null
  }
}
